import { ArticleListPage, ResourceArticle } from "@/components/resources/ArticleListPage";

const posts: ResourceArticle[] = [
  {
    id: "boutique-ia",
    title: "Boutique IA : une boutique complète générée en quelques minutes",
    category: "Nouveauté",
    readTime: "4 min",
    excerpt: "Choisissez votre niche, notre IA crée les produits, les descriptions et le design.",
    body: [
      "Avec Boutique IA, vous choisissez une niche et un plan, puis notre IA génère une boutique prête à vendre : catalogue, descriptions, images et pages essentielles.",
      "Vous gardez ensuite la main sur tout : chaque produit et chaque page restent modifiables depuis l'éditeur.",
    ],
  },
  {
    id: "multilingue",
    title: "Vendez dans plusieurs langues",
    category: "Nouveauté",
    readTime: "3 min",
    excerpt: "Activez les langues de votre choix et laissez vos clients naviguer dans la leur.",
    body: [
      "Dans les paramètres de langues, activez les langues proposées à vos visiteurs et choisissez la langue par défaut.",
      "Vos clients peuvent changer de langue depuis le pied de page de votre boutique, y compris en arabe avec une mise en page de droite à gauche.",
    ],
  },
  {
    id: "fiches-produits",
    title: "5 conseils pour des fiches produits qui convertissent",
    category: "Conseils",
    readTime: "6 min",
    excerpt: "Photos, bénéfices, avis clients : ce qui fait vraiment la différence.",
    body: [
      "1. Montrez le produit sous tous les angles et en situation. 2. Mettez en avant les bénéfices plutôt que les caractéristiques.",
      "3. Affichez clairement le prix et les délais de livraison. 4. Ajoutez des avis clients. 5. Utilisez un appel à l'action visible.",
    ],
  },
  {
    id: "paniers-abandonnes",
    title: "Récupérer les paniers abandonnés",
    category: "Marketing",
    readTime: "5 min",
    excerpt: "Un simple e-mail de relance peut récupérer une part importante des ventes perdues.",
    body: [
      "La plupart des visiteurs qui ajoutent un produit au panier ne finalisent pas leur achat. Une relance envoyée dans les heures qui suivent est souvent efficace.",
      "Proposez un rappel du panier, une réponse aux questions fréquentes et, si pertinent, un petit code de réduction.",
    ],
  },
];

export default function BlogActualites() {
  return (
    <ArticleListPage
      title="Blog et actualités"
      intro="Nouveautés de la plateforme, conseils e-commerce et bonnes pratiques pour développer vos ventes."
      articles={posts}
    />
  );
}
